import { useEffect, useState, useMemo } from "react";
import './trupe.css';
import { useNavigate } from "react-router-dom";
import DescriereModal from "../Components/DescriereModal";
import { useModal } from "../Components/DescriereModal";
import debounce from "lodash.debounce"
import { bandApi } from "../Api/api";

function Trupe(props) {
    const [bands, setBands] = useState([]);
    const [currentGroupList, setCurrentGroupList] = useState([])
    const [groupType, setGroupType] = useState('all')
    const [currentGroup, setCurrentGroup] = useState({})
    const [searchValue, setSearchValue] = useState("");

    const { isOpen, onOpen, onClose } = useModal();

    const navigate = useNavigate();

    const isAdmin = props.isAdmin;

    useEffect(() => {
        bandApi.getAllBands()
            .then((res) => {
                setBands(res.data);
                setCurrentGroup(res.data[0]);
            })
            .catch(() => {
                setBands([]);
            })
    }, []);

    useEffect(() => {
        if (groupType === 'all') {
            bandApi.getAllBands()
                .then((res) => {
                    setBands(res.data);
                    setCurrentGroup(res.data[0]);
                })
                .catch(() => {
                    setBands([]);
                    setCurrentGroup({});
                })
        }
        else {
            if (groupType === "amateurs") {
                bandApi.getAmateurs()
                    .then((res) => {
                        setBands(res.data);
                        setCurrentGroup(res.data[0]);
                        
                    })
                    .catch(() => {
                        setBands([]);
                        setCurrentGroup({});
                    })
            }
            else {
                if (groupType === "professionals") {
                    bandApi.getProfessionals()
                        .then((res) => {
                            setBands(res.data);
                            setCurrentGroup(res.data[0]);
                        })
                        .catch(() => {
                            setBands([]);
                            setCurrentGroup({});
                        })
                }
            }
        }
    }, [groupType])


    const changeCurrentGroup = (id) => {
        const index = bands.findIndex((el) => el.id === id)
        setCurrentGroup(bands[index])
    }

    const onVideoClick = () => {
        window.open(currentGroup.play.linkShow, '_blank');
    }
    const onScenariuClick = () => {
        window.open(currentGroup.play.linkScript, '_blank');
    }
    const onDescriereClick = () => {
        onOpen()
    }

    const deleteTrupa = async (id) => {

        navigate(`/confirm/${id}`)


    };

    const updateTrupa = async (id) => {
        navigate(`/update/${id}`)
    }

    const onHandleSearch = (e) => {
        setSearchValue(e.target.value);
    }

    const debouncedResults = useMemo(() => {
        return debounce(onHandleSearch, 300)
    }, [])

    useEffect(() => {
        return () => {
            debouncedResults.cancel();
        }
    })

    // useEffect(() => {
    //     if (searchValue.trim() !== "") {
    //         const trupeCopy = bands.filter(trupa => trupa.bandName.includes(searchValue));
    //         setBands(trupeCopy);
    //     } else {
    //         bandApi.getAllBands()
    //             .then((res) => {
    //                 setBands(res.data);
    //                 setCurrentGroup(res.data[0]);
    //             })
    //             .catch(() => {
    //                 setBands([]);
    //             })
    //     }


    // }, [searchValue])
    const filteredBands = useMemo(() => {
        if (!searchValue.trim()) {
            return bands;
        }

        const searchTerm = searchValue.toLowerCase();

        return bands.filter((trupa) => {
            return (
                trupa.bandName?.toLowerCase().includes(searchTerm) ||
                trupa.play?.playName?.toLowerCase().includes(searchTerm)
            );
        });
    }, [searchValue, bands]);


    return (
        <div className="page page-trupe">
            <h1>Trupe</h1>
            <div className={'trupe-header'}>
                <div className={' buton '} onClick={() => setGroupType('amateurs')}>Amatori</div>
                <div className={' buton '} onClick={() => setGroupType('professionals')}>Profesioniști</div>
                <div className={' buton '} onClick={() => setGroupType('all')}>Toate trupele</div>
                

            </div>
            <div className={"main-container"}>
                <div className={"group-list"} >


                    <input type="text" name="search" id="search" placeholder="Cauta trupa" onChange={debouncedResults} />

                    <div className={"list-container"}>
                        {filteredBands.map((el, index) => {
                            return (<div className={'group-item'} onClick={() => changeCurrentGroup(el.id)} key={index}>
                                <span>{el.bandName}</span>
                                <span>{el.play.playName}</span>
                                <div className="btn-container-trupe">
                                    {
                                        isAdmin ? <button onClick={() => deleteTrupa(el.id)} className="trupe-btn">DELETE</button> : <></>
                                    }
                                    {
                                        isAdmin ? <button onClick={() => updateTrupa(el.id)} className="trupe-btn">Update</button> : <></>
                                    }
                                </div>
                            </div>)
                        })}
                    </div>
                </div>
                <div className={'group-details'}>
                    < div className={'container-trupa'}>
                        <h1 className={'nume-trupa'}>{currentGroup?.bandName}</h1>
                        <span className={'locatie'}>Localitate: <strong
                        >{currentGroup?.city}</strong>                            </span>
                        <div
                            className={`membri ${currentGroup?.requireAccommodation ? 'green' : 'red'}`}>{currentGroup?.membersNb}</div>
                        <div className={'container-contact'}>
                            <span className={'studii'}>Nume Reprezentant: <strong>{currentGroup?.firstNameRepresentative} {currentGroup?.lastNameRepresentaive}</strong></span>
                            {/* <h3>{currentGroup.prenumeReprezentant} {currentGroup.numeReprezentant}</h3>
                            <span className={'telefon'}>0{currentGroup.numarTlf}</span>
                            <span className={'telefon'}>{currentGroup.email}</span>  */}


                        </div>
                    </div>
                    <div className={'container-piesa'}>
                        <h1 className={'nume-piesa'}>{currentGroup?.play?.playName}</h1>
                        <span className={'autor'}>Autor: <strong>{currentGroup?.play?.author}</strong></span>
                        <div className={'durata'}>{`${currentGroup?.play?.duration} min`}</div>
                        <span className={'gen'}>Gen: <strong>{currentGroup?.play?.genre}</strong></span>
                        <span className={'regie'}>Regie: <strong>{currentGroup?.play?.direction}</strong></span>

                    </div>
                    <div className={'container-decor'}>
                        <h3>Decor</h3>
                        <div className={'decor'}>{currentGroup?.play?.requirements}</div>
                        <div className={'demontare'}>{currentGroup?.play?.disassemblingTime} min</div>
                        <div className={'montare'}>{currentGroup?.play?.assemblingTime} min</div>
                    </div>
                    <div className={'container-butoane'}>
                        <div className={'buton'} onClick={onDescriereClick}>DESCRIERE</div>
                        <div className={'buton'} onClick={onVideoClick}>VIDEO</div>
                        <div className={'buton'} onClick={onScenariuClick}>SCENARIU</div>

                    </div>


                </div>
            </div>

            <DescriereModal onClose={onClose} onOpen={onOpen} isOpen={isOpen} currentGroup={currentGroup} />

        </div>
    )
        ;
}

export default Trupe;

